import React from "react";
import { BUSINESS_HOURS } from "@/core/constants/business";
import { formatTime } from "@/core/utils/formatTime";
import { FaClock } from "react-icons/fa";

interface OpeningHoursProps {
  title?: string;
  className?: string;
  showHeading?: boolean;
}

const OpeningHours: React.FC<OpeningHoursProps> = ({
  title = "Hours of Operation",
  className = "",
  showHeading = true,
}) => {
  // Since all days have the same hours based on business-data.json,
  // we can simplify by showing "Open Daily" with the hours
  const hours = BUSINESS_HOURS.monday;
  const formattedHours =
    typeof hours === "string"
      ? hours
      : `${formatTime(hours.open)} – ${formatTime(hours.close)}`;

  return (
    <section className={`w-full ${className}`}>
      <div className="w-full max-w-full mx-auto text-center lg:text-left">
        {showHeading && (
          <div className="flex items-center justify-center lg:justify-start mb-6">
            <FaClock className="text-cannabis-green-400 text-2xl mr-3" />
            <h2 className="text-3xl font-bold text-white">{title}</h2>
          </div>
        )}

        <div className="py-8">
          <div className="mb-8">
            <h3 className="text-cannabis-green-400 text-2xl font-bold mb-4">
              DC Dispensary Hours
            </h3>
            <div className="flex flex-col space-y-3">
              <p className="text-white text-2xl font-bold">Open Daily</p>
              <p className="text-justice-gold-400 text-3xl font-bold tracking-wide">
                {formattedHours}
              </p>
              <div className="w-16 h-1 bg-cannabis-green-400 rounded-full my-4 mx-auto lg:mx-0"></div>
              <address className="text-white/90 text-lg not-italic">
                3400 Connecticut Avenue NW
                <br />
                Washington, DC 20008
              </address>
            </div>
          </div>

          <p className="text-white/70 text-sm italic">
            * Our business hours may vary on major holidays. Please call ahead
            to confirm.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
